import { useSelector } from 'react-redux';

import { getActionConditions } from 'store/dealManagement/selectors';
import { DealStatus } from 'components/common/types/Deal.types';
import { ProgrammaticStatusOption } from './CampaignBookingStatus.types';

export const CampaignBookingStatusOptionLabel = {
  [DealStatus.PENDING_APPROVAL]: 'Send for approval',
  [DealStatus.APPROVED]: 'Confirm',
  [DealStatus.DRAFT]: 'Draft',
  [DealStatus.CANCELLED]: 'Cancel',
  [DealStatus.REJECTED]: 'Reject',
  [DealStatus.LIVE]: 'Update to Live',
};

export const getCampaignBookingStatusOptions = (): ProgrammaticStatusOption[] => {
  const { cancelDeal, confirmDeal, pendingApprovalDeal, rejectDeal, createDraftDeal, updateEndedOrTerminatedDeal } =
    useSelector(getActionConditions);

  return [
    {
      name: CampaignBookingStatusOptionLabel[DealStatus.DRAFT],
      code: DealStatus.DRAFT,
      isDisabled: createDraftDeal.disabled,
      isVisible: createDraftDeal.show,
    },
    {
      name: CampaignBookingStatusOptionLabel[DealStatus.PENDING_APPROVAL],
      code: DealStatus.PENDING_APPROVAL,
      isDisabled: pendingApprovalDeal.disabled,
      isVisible: pendingApprovalDeal.show,
    },
    {
      name: CampaignBookingStatusOptionLabel[DealStatus.APPROVED],
      code: DealStatus.APPROVED,
      isDisabled: confirmDeal.disabled,
      isVisible: confirmDeal.show,
    },
    {
      name: CampaignBookingStatusOptionLabel[DealStatus.CANCELLED],
      code: DealStatus.CANCELLED,
      isDisabled: cancelDeal.disabled,
      isVisible: cancelDeal.show,
    },
    {
      name: CampaignBookingStatusOptionLabel[DealStatus.REJECTED],
      code: DealStatus.REJECTED,
      isDisabled: rejectDeal.disabled,
      isVisible: rejectDeal.show,
    },
    {
      name: CampaignBookingStatusOptionLabel[DealStatus.LIVE],
      code: DealStatus.LIVE,
      isDisabled: updateEndedOrTerminatedDeal.disabled,
      isVisible: updateEndedOrTerminatedDeal.show,
    },
  ];
};
